import React, { useState, useEffect } from 'react';
import './css/Servicemap.css';
import { getProducts } from '../api/products';
import table from '../assets/table1.png';
import AnimateInView from './AnimateInView';
import { demoProducts } from '../data/demoProducts';

const Servicemap = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await getProducts();
                
                if (!response || !response.data) {
                    throw new Error('No data received from server');
                }

                const fetchedProducts = response.data.products || response.data;
                
                // Validate product data
                const validProducts = fetchedProducts.filter(product => 
                    product && 
                    product.image && 
                    product.image.url && 
                    product.title && 
                    product._id &&
                    product.features &&
                    Array.isArray(product.features)
                );

                // Combine with demo products
                const combinedProducts = [
                    ...validProducts,
                    ...demoProducts
                ].slice(0, 8); // Limit to prevent too many items

                setProducts(combinedProducts);
                setError(null);
            } catch (error) {
                console.error('Error fetching products:', error);
                setError('');
                setProducts(demoProducts);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    const renderProduct = (product, index) => {
        if (!product?.image?.url || !product.title) return null;

        return (
            <AnimateInView delay={0.2} key={product._id || index}>
                <div className={`product-container ${index % 2 === 1 ? 'reverse' : ''}`}>
                    <div className="product-image">
                        <img 
                            src={product.image.url} 
                            alt={product.title}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = table; // Fallback image
                            }}
                        />
                    </div>
                    <div className="product-info">
                        <h2>{product.title}</h2>
                        <p>{product.description}</p>
                        {product.features && Array.isArray(product.features) && (
                            <ul>
                                {product.features.map((feature, idx) => (
                                    <li key={idx}>{feature}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </AnimateInView>
        );
    };

    return (
        <section className='service-map-main-div'>
            {loading && (
                <div className="loading-container">
                    <p>Loading services...</p>
                </div>
            )}

            {error && (
                <div className="error-container">
                    <p>{error}</p>
                </div>
            )}

            {!loading && !error && products.length === 0 && (
                <div className="no-services-container">
                    <p>No services available at the moment.</p>
                </div>
            )}

            {!loading && products.length > 0 && (
                products.map((product, index) => renderProduct(product, index))
            )}
        </section>
    );
};

export default Servicemap;
